import React, { useState } from 'react';
import { t } from '../i18n'; // Import the translation utility
import { Link } from 'react-router-dom';
import llStorage from '../llStorage';
import { loadGatesFromStorage } from '../utils/planGating';
import './Footer.css';
import WheelPopup from './WheelPopup';

function Footer({ language, testMode }) {
  // Determine login status from token
  const token = llStorage.getItem('token'); // logged-in indicator
  // When the site is in test mode, hide the footer only for anonymous visitors
  if (testMode && !token) return null;
  // Determine if paid subscription is active to hide ads for paying users
  const gates = loadGatesFromStorage();
  const isPaidSubscriber = !!token && gates && (
    // Active paid subscription
    (gates.subscription && gates.subscription.isActive && gates.subscription.plan && gates.subscription.plan !== 'free') ||
    // OR active non-free trial
    (gates.trial && gates.trial.isActive && gates.trial.plan && gates.trial.plan !== 'free')
  );

  const [showWheel, setShowWheel] = useState(false);

  return (
    <footer className="footer" style={{ position: 'relative' }}>
      {/* Third-party Ad space (e.g., Google AdSense) - visible only to non-paying or anonymous users */}
      {!isPaidSubscriber && (
        <FooterAdArea language={language} openWheel={() => setShowWheel(true)} />
      )}

      <p>{t('footer.copyright', language)}</p>
      <p>
        <Link to="https://lostlink.store/policies/privacy-policy" target="_blank" rel="noopener noreferrer">
          {t('footer.privacy', language)}
        </Link>
        |
        <Link to="https://lostlink.store/policies/terms-of-service" target="_blank" rel="noopener noreferrer">
          {t('footer.tos', language)}
        </Link>
        |
        <Link to="https://lostlink.store/blogs/help/napoveda" target="_blank" rel="noopener noreferrer">
          {t('footer.help', language)}
        </Link>
        |
        <Link to="https://lostlink.store/pages/contact" target="_blank" rel="noopener noreferrer">
          {t('footer.contact', language)}
        </Link>
        |
        <Link to="https://lostlink.store/blogs/help/napoveda" target="_blank" rel="noopener noreferrer">
          {t('footer.sponsors', language)}
        </Link>        
      </p>

  {showWheel && <WheelPopup onClose={() => setShowWheel(false)} />}

    </footer>
  );
}

export default Footer;

// Small internal component to render clickable ad area and open wheel
function FooterAdArea({ language, openWheel }) {
  return (
    <div className="footer-ad-slot">
      <div className="ad-wrapper" onClick={openWheel} style={{ cursor: 'pointer' }}>
        <img
          className="ad-img"
          src="/images/wheel-970x250-2k-1940x500.webp"
          alt="Ad"
        />
        <div className="ad-overlay">
          <div className="ad-text">{t('footer.adSpace', language) || 'Ad space (hidden for paid subscribers)'}</div>
        </div>
      </div>
    </div>
  );
}